const home = {
    tagLine: "hulp bij afvallen, spiermassa opbouwen en je zelfverzekerd voelen zonder jouw persoonlijke leven op te geven!",
    offer: "Ik bied verschillende 1-op-1 online coaching pakketten aan maar ook maandelijkse trainings en voedingsplannen!",
    button: "TRANSFORMEER JE LEVEN"
}

export default home;